import { Injectable } from '@angular/core';

/**
 * Host chrome state (rail dock, active tab, zoom) that outlives one surface mount. A container that remounts
 * the surface per record — a board preview pane — provides one, so the next record's first paint starts from
 * what the user last saw instead of defaults that then snap into place. Containers without it keep per-mount state.
 */
@Injectable()
export class SurfaceMountMemory {

  private readonly slots = new Map<string, unknown>();

  public read<T>(slot: string): T | undefined {

    return this.slots.get(slot) as T | undefined;
  }

  public write<T>(slot: string, value: T): void {

    this.slots.set(slot, value);
  }
}
